/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CredentialIssuanceCompletionRequest,
  NotifyRetryRequireRequest,
  ResponseDto,
  UpdateCrederRequest,
} from '../models/index';
import {
    CredentialIssuanceCompletionRequestFromJSON,
    CredentialIssuanceCompletionRequestToJSON,
    NotifyRetryRequireRequestFromJSON,
    NotifyRetryRequireRequestToJSON,
    ResponseDtoFromJSON,
    ResponseDtoToJSON,
    UpdateCrederRequestFromJSON,
    UpdateCrederRequestToJSON,
} from '../models/index';

export interface CompleteInstance2Request {
    workflowInstanceId: string;
    credentialIssuanceCompletionRequest: CredentialIssuanceCompletionRequest;
}

export interface RetryNotificationRequest {
    workflowInstanceId: string;
    notifyRetryRequireRequest: NotifyRetryRequireRequest;
}

export interface TerminateInstanceRequest {
    workflowInstanceId: string;
    notifyRetryRequireRequest: NotifyRetryRequireRequest;
}

export interface UpdateCrederOperationRequest {
    updateCrederRequest: UpdateCrederRequest;
}

/**
 * 
 */
export class PrivateCredentialIssuanceWorkflowControllerApi extends runtime.BaseAPI {

    /**
     * Complete Credential Issuance Workflow instance
     */
    async completeInstance2Raw(requestParameters: CompleteInstance2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDto>> {
        if (requestParameters['workflowInstanceId'] == null) {
            throw new runtime.RequiredError(
                'workflowInstanceId',
                'Required parameter "workflowInstanceId" was null or undefined when calling completeInstance2().'
            );
        }

        if (requestParameters['credentialIssuanceCompletionRequest'] == null) {
            throw new runtime.RequiredError(
                'credentialIssuanceCompletionRequest',
                'Required parameter "credentialIssuanceCompletionRequest" was null or undefined when calling completeInstance2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/workflow/.private/credential-issuance/{workflow_instance_id}/completion`.replace(`{${"workflow_instance_id"}}`, encodeURIComponent(String(requestParameters['workflowInstanceId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CredentialIssuanceCompletionRequestToJSON(requestParameters['credentialIssuanceCompletionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDtoFromJSON(jsonValue));
    }

    /**
     * Complete Credential Issuance Workflow instance
     */
    async completeInstance2(requestParameters: CompleteInstance2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDto> {
        const response = await this.completeInstance2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Notify user that Credential Issuance Workflow should be retried
     */
    async retryNotificationRaw(requestParameters: RetryNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDto>> {
        if (requestParameters['workflowInstanceId'] == null) {
            throw new runtime.RequiredError(
                'workflowInstanceId',
                'Required parameter "workflowInstanceId" was null or undefined when calling retryNotification().'
            );
        }

        if (requestParameters['notifyRetryRequireRequest'] == null) {
            throw new runtime.RequiredError(
                'notifyRetryRequireRequest',
                'Required parameter "notifyRetryRequireRequest" was null or undefined when calling retryNotification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/workflow/.private/credential-issuance/{workflow_instance_id}/retry-notification`.replace(`{${"workflow_instance_id"}}`, encodeURIComponent(String(requestParameters['workflowInstanceId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NotifyRetryRequireRequestToJSON(requestParameters['notifyRetryRequireRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDtoFromJSON(jsonValue));
    }

    /**
     * Notify user that Credential Issuance Workflow should be retried
     */
    async retryNotification(requestParameters: RetryNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDto> {
        const response = await this.retryNotificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Terminate Cred issue workflow instance
     */
    async terminateInstanceRaw(requestParameters: TerminateInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDto>> {
        if (requestParameters['workflowInstanceId'] == null) {
            throw new runtime.RequiredError(
                'workflowInstanceId',
                'Required parameter "workflowInstanceId" was null or undefined when calling terminateInstance().'
            );
        }

        if (requestParameters['notifyRetryRequireRequest'] == null) {
            throw new runtime.RequiredError(
                'notifyRetryRequireRequest',
                'Required parameter "notifyRetryRequireRequest" was null or undefined when calling terminateInstance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/workflow/.private/credential-issuance/{workflow_instance_id}/terminate`.replace(`{${"workflow_instance_id"}}`, encodeURIComponent(String(requestParameters['workflowInstanceId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NotifyRetryRequireRequestToJSON(requestParameters['notifyRetryRequireRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDtoFromJSON(jsonValue));
    }

    /**
     * Terminate Cred issue workflow instance
     */
    async terminateInstance(requestParameters: TerminateInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDto> {
        const response = await this.terminateInstanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update creder value
     */
    async updateCrederRaw(requestParameters: UpdateCrederOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDto>> {
        if (requestParameters['updateCrederRequest'] == null) {
            throw new runtime.RequiredError(
                'updateCrederRequest',
                'Required parameter "updateCrederRequest" was null or undefined when calling updateCreder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/workflow/.private/credential-issuance/creder`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCrederRequestToJSON(requestParameters['updateCrederRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update creder value
     */
    async updateCreder(requestParameters: UpdateCrederOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDto> {
        const response = await this.updateCrederRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
